module.exports = __webpack_public_path__ + "img/pina-colada.cb38b8d6.jpg";